<script setup>
const props = defineProps({
  width: {
    type: Number,
    default: 16,
  },
  height: {
    type: Number,
    default: 18,
  },
});
</script>

<template>
  <svg
    :width="props.width"
    :height="props.height"
    viewBox="0 0 11 10"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
  >
    <path
      d="M7.68298 6.73681L8.2941 6.1119C8.38959 6.01426 8.55574 6.08261 8.55574 6.22321V9.06264C8.55574 9.58014 8.14514 10 7.63905 10H0.916687C0.410599 10 0 9.58014 0 9.06264V2.18864C0 1.67114 0.410599 1.25128 0.916687 1.25128H6.13989C6.27548 1.25128 6.34423 1.41923 6.24875 1.51882L5.63762 2.14373C5.60898 2.17302 5.57078 2.18864 5.52877 2.18864H0.916687V9.06264H7.63905V6.84617C7.63905 6.80516 7.65433 6.7661 7.68298 6.73681ZM10.6737 2.79598L5.65863 7.92413L3.9322 8.11942C3.43185 8.17605 3.00597 7.74447 3.06135 7.22892L3.25233 5.46356L8.26737 0.3354C8.7047 -0.1118 9.41131 -0.1118 9.84674 0.3354L10.6718 1.17903C11.1091 1.62623 11.1091 2.35073 10.6737 2.79598V2.79598ZM8.78682 3.3994L7.67725 2.2648L4.12891 5.89513L3.9895 7.17034L5.23657 7.02778L8.78682 3.3994ZM10.0243 1.84299L9.19933 0.999365C9.12103 0.919299 8.99308 0.919299 8.91669 0.999365L8.32657 1.60279L9.43614 2.73739L10.0263 2.13396C10.1026 2.05195 10.1026 1.92306 10.0243 1.84299V1.84299Z"
    />
  </svg>
</template>
